import Vue from 'vue'
import Util from './utils/Util'
import ConstCode from './constants/ConstCode'
import _ from 'lodash'

import CommonSvc from './service/CommonSvc'
import AccountSvc from './service/AccountSvc'
import MypageSvc from './service/MypageSvc'
import AssetSvc from './service/AssetSvc'
import MainSvc from './service/MainSvc'
import CertSvc from './service/CertSvc'

let globalVue = Vue
Vue.prototype.$_ = _
Vue.prototype.$Util = Util
Vue.prototype.$ConstCode = ConstCode
Vue.prototype.$windowOpen = (url) => window.open(url, '_blank')
Vue.prototype.$scrollToTop = () => Util.scrollToTop(250)
Vue.prototype.$alert = (msg, duration) => Util.toastAlert(globalVue, msg, duration)
Vue.prototype.$confirm = (msg, actions, duration) => Util.toastConfirm(globalVue, msg, actions, duration)

Vue.prototype.$CommonSvc = CommonSvc
Vue.prototype.$AccountSvc = AccountSvc
Vue.prototype.$MypageSvc = MypageSvc
Vue.prototype.$AssetSvc = AssetSvc
Vue.prototype.$MainSvc = MainSvc
Vue.prototype.$CertSvc = CertSvc

Vue.prototype.$PopupTerminal = null
Vue.prototype.$windowOpenPop = (url, parent) => {
  window.open(url, '_blank', `width=980, height=800`)
  Vue.prototype.$PopupTerminal = parent
}

Vue.prototype.$EventBus = new Vue()

